<template lang="pug">
  span
    el-select.prjSelect(
      v-if="!readonly"
      size="small"
      filterable remote
      clearable
      v-model="prjValue"
      v-loadMore="getPrjOptions_add"
      :remote-method="projectFilter"
      @change="changeProject"
      @visible-change="tagChange")
      el-option-group(v-for="group in allPrjOptions" :key="group.label" :label="group.label")
        el-option.prjStyle(v-for="item in group.options" :key="item.prjId" :label="item.prjName" :value="item.prjId" :title="item.prjName")
    span(v-if="readonly") {{ "【" + prjName + "】" || "--" }}
</template>

<script>
import { mapState } from "vuex";
import XtDesignService from "@/CommonDP/service/XtDesign-service";

export default {
  props: {
    prjId: {
      type: String,
      default: ""
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      prjValue: "", // 下拉框绑定项目
      prjName: "",
      page: {
        pageNum: 1,
        count: 0,
        totalPage: 1
      }, // 分页
      keyword: "",
      hisOptions: [], // 历史列表
      prjOptions: [] // 项目列表
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    allPrjOptions() { // 分组项目列表
      const his = {
        label: "最近访问",
        options: [...this.hisOptions]
      };
      const prj = {
        label: "项目列表",
        options: [...this.prjOptions]
      };
      const options = [];
      if (this.hisOptions.length) options.push(his);
      if (this.prjOptions.length) options.push(prj);
      return options;
    }
  },

  watch: {
    prjId() {
      this.dealPrjInfoChanged();
    }
  },

  mounted () {
    if (this.readonly) {
      this.queryPrjName();
    } else {
      this.initSelect();
    }
  },
  methods: {
    initSelect() {
      let prjIdFromStore = false;
      if (this.prjId) {
        this.prjValue = this.prjId;
      } else {
        this.prjValue = this.prjInfo.prjId;
        prjIdFromStore = true;
      }
      this.getHisOptions(); // 最近访问项目
      this.getPrjOptions(); // 项目列表
      if (prjIdFromStore) {
        this.$nextTick();
        this.changeProject(this.prjValue);
      }
    },

    async queryPrjName() {
      if (!this.prjId) {
        this.prjName = "";
        return;
      }
      this.prjName = await XtDesignService.queryPrjName(this.prjId);
    },

    async dealPrjInfoChanged() {
      console.debug("...dealPrjInfoChanged..", this.prjId);
      await this.$nextTick();
      if (this.readonly) {
        await this.queryPrjName();
      } else {
        this.prjValue = this.prjId;
      }
    },

    // 分页增加
    getPrjOptions_add: _.debounce(async function () {
      const { pageNum, totalPage } = this.page;
      if (Number(pageNum) < Number(totalPage)) {
        const num = Number(pageNum) + 1;
        const params = {
          enterpriseId: this.enterpriseId,
          pageNum: num,
          pageSize: 10,
          keyword: this.keyword
        };
        const res = await XtDesignService.getProjectsByUserIdWithPage(params);
        this.page.count = res.totalCount;
        this.page.pageNum = res.pageIndex;
        this.page.totalPage = res.totalPage;
        this.prjOptions = [...this.prjOptions, ...res.data];
      }
    }, 500),
    // 项目下拉框--弹框显隐
    tagChange(val) {
      if (val === false) {
        this.keyword = "";
        this.getHisOptions();
        this.getPrjOptions();
      }
    },
    // 下拉框切换项目
    async changeProject(prjId) {
      if (prjId) {
        const options = [...this.hisOptions, ...this.prjOptions];
        let project = {};
        options.forEach((item) => {
          if (item.prjId === prjId) project = { ...item };
        });
        if (project.prjId) this.$store.dispatch("updatePrj", project);
        this.$emit("changeProject", prjId);
        this.tagChange(false);
      }
    },
    // 获得最近访问
    async getHisOptions() {
      const params = {
        enterpriseId: this.enterpriseId,
        businessType: "prj",
        clientType: "web",
        keyword: this.keyword
      };
      const res = await XtDesignService.getUserVisitHistory(params);
      this.hisOptions = res.data;
      this.$store.dispatch("setHisOptions", res.data);
    },
    // 获得项目列表
    async getPrjOptions() {
      this.page = { pageNum: 1, count: 0, totalPage: 1 };
      const params = {
        enterpriseId: this.enterpriseId,
        pageNum: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      const res = await XtDesignService.getProjectsByUserIdWithPage(params);
      this.page.count = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.page.totalPage = res.totalPage;
      this.prjOptions = res.data;
    },
    // 项目下拉框过滤关键字
    projectFilter(val) {
      this.keyword = val || "";
      this.getHisOptions();
      this.getPrjOptions();
    }
  }
};
</script>

<style lang="scss" scoped>
.prjStyle {
  max-width: 300px;
}
</style>
